import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';
import { Typography } from '~/shared/ui/Typography/Typography';

export const Root = styled.div`
  background: ${uiToken.color.background.transparent};
  border: ${uiToken.color.border.default} 0.5px solid;
  border-radius: 12px;
  padding: 32px 24px 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const IconContainer = styled.div`
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 3px solid #ff4757;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  background: transparent;
`;

export const CloseIcon = styled.div`
  width: 32px;
  height: 32px;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 24px;
    height: 3px;
    background: #ff4757;
    border-radius: 2px;
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export const Description = styled(Typography.Small)`
  color: #ffffffb2;
  font-size: 12px;
`;

export const Title = styled(Typography.H2)`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`;
